import { gql } from '@apollo/client'

import { SHOP_CART_FRAGMENT, CUSTOMER_FRAGMENT } from '../fragments'

export const CHECKOUT = gql`
  mutation Checkout($input: CheckoutInput!) {
    checkout(input: $input) {
      order {
        id
        uuid
      }
      payment {
        ... on StripePaymentIntent {
          clientSecret
          status
        }
      }
    }
  }
`

export const UPDATE_CART_FULFILLMENT = gql`
  mutation UpdateCartFulfillment(
    $kind: ShopCartFulfillmentKind!
    $locationId: ID
    $customerAddressId: ID
    $address: ShopCartFulfillmentAddressInput
    $courierAction: ShopCartFulfillmentCourierAction
  ) {
    updateCartFulfillment(
      input: {
        kind: $kind
        locationId: $locationId
        customerAddressId: $customerAddressId
        address: $address
        courierAction: $courierAction
      }
    ) {
      cart {
        ...ShopCart
      }
      customer {
        ...Customer
      }
    }
  }
  ${SHOP_CART_FRAGMENT}
  ${CUSTOMER_FRAGMENT}
`

export const CALC_SHIPPING_COST = gql`
  mutation CalcShippingCost($address: ShopCartFulfillmentAddressInput) {
    calcShippingCost(input: { address: $address }) {
      cart {
        ...ShopCart
      }
    }
  }
  ${SHOP_CART_FRAGMENT}
`
